export enum FormTransactionType {
    SUBMIT, CANCEL, CLEAR
}
